import React from "react";
import { useField } from "formik";
import NumberInputBase from "./NumberInputBase";

interface NumberInputProps {
    label: string;
    name: string;
    min: number;
    max: number;
    disabled?: boolean;
    readOnly?: boolean;
    value?: number;
}

const NumberInput: React.FC<NumberInputProps> = (props) => {
    const [field, meta, helpers] = useField<number>(props.name);
    const actualValue = props.value !== undefined ? props.value : field.value;

    const handleChange = (val: number) => {
        if (props.value !== undefined) {
            return;
        }

        if (val > props.max) val = props.max;
        if (val < props.min) val = props.min;
        helpers.setValue(val);
    };

    return (
        <NumberInputBase
            label={props.label}
            min={props.min}
            max={props.max}
            disabled={props.disabled}
            readOnly={props.readOnly}
            value={actualValue}
            error={meta.error ?? null}
            onChange={handleChange}
        />
    );
};

export default NumberInput;
